import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { AuthService } from '../utils/authService'

interface PublicRouteProps {
  children: ReactNode
}

/**
 * PublicRoute component - Prevents authenticated users from accessing public routes
 * (landing page, login, sign-up, etc.)
 * Redirects authenticated users to the dashboard
 */
export default function PublicRoute({ children }: PublicRouteProps) {
  const isAuthenticated = AuthService.isAuthenticated()

  if (isAuthenticated) {
    // Redirect authenticated users to dashboard
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}

